import { MixedObject } from '@core/interfaces/mixed-object';

export class TableParams {
  [key: string]: any;

  public column = 'id';
  public direction = 'asc';
  public pageNumber = 1;
  public limit = 10;
  public searchTerm = '';
  public dateFrom?: number;
  public dateTo?: number;
  public excludeGlobalLoader = false;
  public lang?: string;
  public additionalParams: MixedObject = {};
  public clientId?: number;
  public userId?: number;
  public clientIp?: string;
  public responseCode?: number;
  public requestMethod?: string;

  constructor(data?: Partial<TableParams>) {
    Object.assign(this, data);
  }

  public get(name: string): string | number | null {
    return this.hasOwnProperty(name) ? this[name] : null;
  }

  public delete(name: string): void {
    if (typeof this[name] !== 'function') {
      delete this[name];
    } else {
      console.log(`${name} is a method and cannot be deleted`);
    }
  }

  public toPlainObject(): MixedObject<number | string> {
    const params: MixedObject = {};
    for (const key of Object.keys(this)) {
      if (this.get(key)) {
        if (['excludeGlobalLoader', 'additionalParams'].includes(key)) {
          continue;
        }
        params[key] = this.get(key);
      }
    }
    for (const key of Object.keys(this.additionalParams)) {
      if (this.additionalParams[key]) {
        params[key] = this.additionalParams[key];
      }
    }

    return params;
  }

  public toString(): string {
    const params = [];
    const plainObj = Object.entries(this.toPlainObject());
    for (const [key, value] of plainObj) {
      params.push(`${key}=${value}`);
    }
    return params.join('&');
  }

  public getUrlParams(): string {
    const params = this.toString();
    return params.length ? `?${params}` : '';
  }
}
